import { isEqual } from 'lodash-es';
import qs from 'qs';

export default function writeValueToRouterWithoutReactivity<T>({
  writeValueToRouteQuery,
}: {
  writeValueToRouteQuery: (routeQuery: Record<string, unknown>, value: T) => Record<string, unknown>;
}) {
  return (nextValue: T) => {
    const currentRouteQuery = qs.parse(globalThis.location.search, {
      ignoreQueryPrefix: true,
    });

    const nextRouteQuery = writeValueToRouteQuery(currentRouteQuery, nextValue);

    const isRouteQueryChanged = !isEqual(currentRouteQuery, nextRouteQuery);

    if (!isRouteQueryChanged) {
      return;
    }

    const stringifiedQuery = qs
      .stringify(nextRouteQuery, {
        addQueryPrefix: true,
        encode: false,
      })
      .trim();

    globalThis.history.replaceState(globalThis.history.state, '', `${globalThis.location.pathname}${stringifiedQuery}`);
  };
}
